import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalleryDto, GalleryPresetDto } from '@picflow/types';
import { ProTagComponent } from '../../../shared-extra/components/pro-tag/pro-tag.component';
import { PermissionsPipe } from '../../../shared-extra/pipes/permissions.pipe';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-gallery-settings-presets-context',
  templateUrl: './gallery-settings-presets-context.component.html',
  styleUrls: ['./gallery-settings-presets-context.component.scss'],
  standalone: true,
  imports: [ButtonMenuItemComponent, SvgComponent, ProTagComponent, PermissionsPipe],
})
export class GallerySettingsPresetsContextComponent {
  @Output() applyPreset: EventEmitter<GalleryPresetDto> = new EventEmitter();
  @Output() createPreset = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() currentPreset: GalleryPresetDto;
  @Input() customPresets: GalleryPresetDto[];
  @Input() standardPresets: GalleryPresetDto[];
  @Input() gallery: GalleryDto;
}
